"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    var taskList = frame.params ? frame.params.taskList : [];
    var device = virtual.device;
    var subDevice = virtual.subDevice;
    virtual.task.forEach(function (t) { return clearTimeout(t); });
    virtual.task = (taskList || [])
        .filter(function (t) { return !t.subDevTid || t.subDevTid === subDevice.devTid; })
        .map(function (_a) {
        var taskId = _a.taskId, delayTime = _a.delayTime, task = _a.task;
        return setTimeout(function () {
            if (device.workModeType !== 'JSON_TRANSPARENT_NOT_CHECK_RAW') {
                virtual.send('timerReport', {
                    task: task,
                    taskId: taskId
                });
            }
        }, delayTime * 1000);
    });
    // 发送心跳包
    setTimeout(function () {
        virtual.send('heartbeat');
    }, virtual.options.heartbeat);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/getTimerListResp.ts